import React, { useState , useEffect } from 'react';
import { makeStyles } from '@material-ui/core'
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Pagination, Navigation, EffectFade } from 'swiper';
import Card from './Card';
import './Card/index.css';
import { useDispatch, useSelector } from 'react-redux';
import {actionTypes} from './../../../../../redux/slider/select_slider/index'

// SwiperCore.use([Navigation]);
// SwiperCore.use([Autoplay]);

let useSyles = makeStyles(() => ({
    root: {
        width: '100%',
        maxWidth: '100%', 
        height: '100%',
        '& > div ':{
            marginBottom:15,
        }
    },
}))

export default function Index() {

    let classes = useSyles();
    const dispatch = useDispatch();

    const [sort, setSort] = useState({});
    const [state, setstate] = useState([]);
    const [flagApi, setflagApi] = useState(false);
    const [stateTable, setStateTable] = useState({});
    const [pagnation, setPagnation] = useState({ number: 1, count: 2 });


    const stateReducer = useSelector(state => state.select_slider_reducer)



    const apiSubmit = () => {
        let obj = {};
        let { size } = stateReducer;
        let { id, ...sortRes } = sort;

        Object.keys(stateTable).forEach((element) => {
            if (stateTable[element]) {
                obj[element] = stateTable[element];
            }
        });

        let _data = {
            data: obj,
            from: pagnation.number,
            size: size,
            sort_by: sortRes,
        };

        // dispatch({ type: actionTypes.selectSliderAsync, payload: _data })

    };


    useEffect(() => {
        setstate(stateReducer.data);
        setPagnation((prev) => ({
          ...prev,
          count: Math.ceil(stateReducer.total / stateReducer.size),
        }));
      }, [stateReducer]); //eslint-disable-line react-hooks/exhaustive-deps

      
      useEffect(() => {
     
          apiSubmit();
        
      }, [flagApi])//eslint-disable-line react-hooks/exhaustive-deps

      





    let data = [
        // {
        //     title: "خرید سیمان از بورس",
        //     desce: "با قیمت رقابتی در کارگزاری پویان سیمان بخرید",
        //     file: '/assets/images/slider/3.png',
        //     btnRed: {
        //         title: 'ثبت‌ نام در بورس کالا',
        //         link: 'https://pouyan.ebgo.ir',
        //     },
        //     btnWhite: {
        //         title: 'تماس و مشاوره',
        //         phone: '02153782000'
        //     },
        // },
        {
            title: "خرید خودرو از بورس کالا",
            desce: "خرید خودرو از بورس کالا  امکان‌پذیر شد",
            file: '/assets/images/slider/2.png',
            btnRed: {
                title: 'ثبت‌ نام در بورس کالا',
                link: 'https://pouyan.ebgo.ir',
            },
            btnWhite: {
                title: 'تماس و مشاوره',
                phone: '02153782000'
            },
        },

        // {
        //     title: "خرید محصولات پتروشیمی از بورس",
        //     desce: "با قیمت رقابتی محصولات پتروشیمی را در کارگزاری پویان سیمان بخری",
        //     file: '/assets/images/slider/5.png',
        //     btnRed: {
        //         title: 'ثبت‌ نام در بورس کالا',
        //         link: 'https://pouyan.ebgo.ir',
        //     },
        //     btnWhite: {
        //         title: 'تماس و مشاوره',
        //         phone: '02153782000'
        //     },
        // },
        // {
        //     title: "خرید فولاد و میلگرد از بورس",
        //     desce: "با قیمت رقابتی در کارگزاری پویان میلگرد بخرید",
        //     file: '/assets/images/slider/4.png',
        //     btnRed: {
        //         title: 'ثبت‌ نام در بورس کالا',
        //         link: 'https://pouyan.ebgo.ir',
        //     },
        //     btnWhite: {
        //         title: 'تماس و مشاوره',
        //         phone: '02153782000'
        //     },
        // },
        {
            title: "از نزول قیمت‌ها در بازار طلا سود کنید",
            desce: "در واحد آتی از آموزش تا معاملات در کنار شما هستیم",
            file: '/assets/images/slider/1.png',
            btnRed: {
                title: 'ثبت‌ نام در بورس کالا',
                link: 'https://pouyan.ebgo.ir',
            },
            btnWhite: {
                title: 'تماس و مشاوره',
                phone: '02153782000'
            },
        },
        {
            title: "بورس کالا و انرژی",
            desce: " ارائه تمامی خدمات پذیرش، مشاوره و معامله",
            file: '/assets/images/slider/7.png',
            btnRed: {
                title: 'ثبت‌ نام در بورس کالا',
                link: 'https://pouyan.ebgo.ir',
            },
            btnWhite: {
                title: 'تماس و مشاوره',
                phone: '02153782000'
            },
        },
        {
            title: "معاملات آسان و حرفه ای اوراق بهادار",
            desce: "برای هر مشتری پیشنهادات ویژه ای داریم  ",
            file: '/assets/images/slider/6.png',
            btnRed: {
                title: "دریافت کد معاملاتی",
                link: 'https://reg.pouyanbroker.ir',
            },
            btnWhite: {
                title: 'تماس و مشاوره',
                phone: '02153782000'
            },
        },
       
    ]

    return (
        <div className={classes['root']}>
            <Swiper
         
                slidesPerView={'auto'}
                spaceBetween={0}
                // breakpoints={{
                //     640: {
                //         width: '100%',
                //         slidesPerView: 1,
                //         spaceBetween: 1000,
                //     },
                // }
                // }
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                }}
                centeredSlides={true}
                loop={state?.length > 1 ? true : false}
                // onSlideChange={() => }
                // onSwiper={(swiper) => }
                modules={[Autoplay, Pagination, Navigation]}
                pagination={{
                    clickable: true,
                }}
                className="mySwiper"
                navigation={{
                    prevEl: '.prevNavigation',
                    nextEl: '.nextNavigation',
                }}

            >
                {
                    state
                    ?.filter((item)=> item?.body?.is_visible === 'TRUE')
                    ?.map((silde, index) => {
                        return (
                            <SwiperSlide key={index}>
                                <Card
                                key={index}
                                    data={silde}
                                    flagShowArrow={state?.length > 1}
                                />
                            </SwiperSlide>
                        )
                    })
                }
            </Swiper>

<button className="prevNavigation" id='prevNavigation' style={{width:0 , overflow:'hidden' , display:'none'}}>prevNavigation</button>
<button className="nextNavigation" id='nextNavigation' style={{width:0 , overflow:'hidden',display:'none'}}>nextNavigation</button>
        </div >)
        ;
}
